export const breakpoints = {
  md: "48em",
  lg: "64em",
};
